import {
  collection,
  addDoc,
  onSnapshot,
  query,
  orderBy,
  Timestamp,
  Unsubscribe,
} from 'firebase/firestore'
import { signInWithCustomToken } from 'firebase/auth'
import { firestore, firebaseAuth } from './firebaseConfig'
import { ChatMessage } from '../types'

export const signInToFirebase = async (customToken: string): Promise<void> => {
  if (!firebaseAuth) throw new Error('Firebase not initialized')
  await signInWithCustomToken(firebaseAuth, customToken)
}

export const sendMessage = async (
  conversationId: string,
  text: string,
  senderId: number
): Promise<void> => {
  if (!firestore) throw new Error('Firebase not initialized')
  const messagesRef = collection(firestore, 'conversations', conversationId, 'messages')
  await addDoc(messagesRef, {
    text,
    senderId,
    createdAt: Timestamp.now(),
  })
}

export const subscribeToMessages = (
  conversationId: string,
  onMessage: (messages: ChatMessage[]) => void
): Unsubscribe => {
  if (!firestore) return () => {}
  const messagesRef = collection(firestore, 'conversations', conversationId, 'messages')
  const q = query(messagesRef, orderBy('createdAt', 'asc'))

  // IMPORTANT: Unsubscribe on component unmount to prevent memory leaks
  return onSnapshot(q, (snapshot) => {
    const messages: ChatMessage[] = snapshot.docs.map((doc) => ({
      id: doc.id,
      text: doc.data().text,
      senderId: doc.data().senderId,
      timestamp: (doc.data().createdAt as Timestamp).toMillis(),
    }))
    onMessage(messages)
  })
}
